"use client";

import { motion } from "motion/react";
import { useRef } from "react";

import { motionTransition } from "../config/animation";

import HeroOverlay from "./hero-overlay";

import { Image } from "@/features/common/components/ui/image";

interface HeroImage {
  src: string;
  alt?: string;
  className?: string;
}

interface HeroImagesProps {
  images: {
    primaryImage: HeroImage;
  };
}

export default function HeroImages({ images }: HeroImagesProps) {
  const { primaryImage } = images;

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center justify-end max-lg:hidden md:w-1/2"
      initial={{ opacity: 0, y: 40 }}
      transition={motionTransition}
    >
      <div
        ref={containerRef}
        className="relative flex h-125 w-125 flex-col items-start justify-center bg-contain bg-center bg-no-repeat"
      >
        <Image
          removeWrapper
          alt={primaryImage.alt ?? ""}
          className={`absolute inset-0 z-10 h-full w-full rounded-md object-cover opacity-100 ${primaryImage.className ?? ""}`}
          src={
            primaryImage.src.startsWith("/")
              ? primaryImage.src
              : `/${primaryImage.src}`
          }
        />

        <HeroOverlay
          containerRef={containerRef}
          src="/img/main-page/hero-section-overlay-1-img.webp"
        />
        <HeroOverlay
          containerRef={containerRef}
          src="/img/main-page/hero-section-overlay-2-img.webp"
        />
      </div>
    </motion.div>
  );
}
